export const QUESTS = {
  love: [
    {
      text: "ดวงความรักช่วงนี้มันอึมครึม เหมือนฟ้าฝนไม่เป็นใจ",
      action: "อยากได้คู่ ต้องไป 'รำแก้บน' ที่พระธาตุพนม จ.นครพนม",
      detail: "ต้องรำท่านกบินหลา 3 รอบ แล้วซื้อ 'ผ้าครามสกลนคร' มาพันคอตอนนอน จะดึงดูดเนื้อคู่สายอาร์ตเข้ามา",
      stat: "เสน่ห์ +50",
      location: "นครพนม",
      product: "ผ้าครามสกล"
    },
    {
      text: "เนื้อหอมแต่เจอแต่แมลงวันตอม ไม่เจอผึ้งเลย",
      action: "ไปกิน 'ข้าวซอยน้อย' ที่เชียงราย ด่วน!",
      detail: "เวลากินต้องนั่งหันหน้าทิศเหนือ แล้วซื้อ 'ชาอูหลง' กลับมาฝากคนที่แอบชอบ รับรองเขาตาสว่างเห็นความดีเราแน่",
      stat: "วาสนา +30",
      location: "เชียงราย",
      product: "ชาอูหลง"
    },
    {
      text: "แฟนเก่าจะกลับมา... มาขอตังค์!",
      action: "แก้เคล็ดด้วยการไปเดินตลาดน้ำอัมพวา จ.สมุทรสงคราม",
      detail: "ซื้อ 'ปลาทูหน้างอคอหัก' ไปทอดกินกับครอบครัว พลังแห่งปลาทูจะช่วยหักคอพวกมารผจญออกไปจากชีวิต",
      stat: "กรรม -20",
      location: "สมุทรสงคราม",
      product: "ปลาทูแม่กลอง"
    }
  ],
  work: [
    {
      text: "งานหนักไม่กลัว กลัวเจ้านายไม่เห็นค่า",
      action: "อยากเลื่อนขั้น ต้องไป 'คำชะโนด' จ.อุดรธานี",
      detail: "อย่าลืมแวะซื้อ 'หมูยออุบล' กลับไปฝากหัวหน้า วางบนโต๊ะเขาตอน 9 โมงเช้า พลังหมูยอจะทำให้เขาเอ็นดูเราเหมือนลูกหลาน",
      stat: "เมตตา +80",
      location: "อุดรธานี",
      product: "หมูยอ"
    },
    {
      text: "ธุรกิจติดขัด ลูกน้องอู้ งานไม่เดิน",
      action: "ต้องไปไหว้ 'ศาลเจ้าพ่อหลักเมือง' จ.ขอนแก่น",
      detail: "ขากลับต้องซื้อ 'ไก่ย่างเขาสวนกวาง' แจกลูกน้องคนละตัว ไก่จะจิกเรียกสติให้กลับมาทำงานขยันขันแข็ง",
      stat: "บารมี +40",
      location: "ขอนแก่น",
      product: "ไก่ย่างเขาสวนกวาง"
    }
  ],
  power: [
    {
      text: "อยากมีอำนาจวาสนา เป็นเจ้าคนนายคน",
      action: "ไปไหว้ 'วัดเจดีย์ (ไอ้ไข่)' จ.นครศรีธรรมราช",
      detail: "สำคัญมาก! ต้องไปขอเลขเด็ดกับ 'คนขายปลาหมึกปิ้ง' แถวหาดปากพนัง กินปลาหมึกแล้วจะเหนียวแน่น ไม่มีใครเลื่อยขาเก้าอี้ได้",
      stat: "อำนาจ +99",
      location: "นครศรีธรรมราช",
      product: "ปลาหมึกปิ้งปากพนัง"
    }
  ],
  health: [
    {
      text: "ปวดหลัง ออฟฟิศซินโดรมถามหา",
      action: "ต้องไปแช่ 'น้ำพุร้อนระนอง' จ.ระนอง",
      detail: "แช่เสร็จต้องกิน 'แกงไตปลา' ให้เหงื่อออก รูขุมขนจะเปิดรับพลังงานจักรวาล ขับไล่ความขี้เกียจออกจากร่างกาย",
      stat: "พลังกาย +60",
      location: "ระนอง",
      product: "แกงไตปลา"
    }
  ]
};

export type Topic = keyof typeof QUESTS;
